/**
 * Textos de la landing pública (sin sesión) de ava-client — TALAPP-1916.
 * Todo el copy de la landing vive acá; los componentes de `pages/home/` solo
 * lo renderizan.
 */

export const LANDING_BRAND = {
  name: "AVA",
  product: "Onboarding",
};

export const LANDING_ROUTES = {
  login: "/login",
  register: "/register",
};

export const LANDING_HERO = {
  title: "Tu onboarding digital en minutos",
  subtitle:
    "Solicitá la apertura de tu cuenta desde donde estés y en minutos. Un trámite ágil, seguro y automatizado: subís tus documentos y nuestra tecnología completa los datos por vos.",
  cta: "Crear cuenta",
  loginPrompt: "¿Ya tenés cuenta?",
  loginLabel: "Iniciar sesión",
};

// Enlace externo al sitio de ADF (decisión de Victoria): abre en otra pestaña
// y el nombre accesible lo avisa.
export const LANDING_MORE = {
  prompt: "¿Querés saber más del producto?",
  label: "Conocé más",
  href: "https://adfcloudia.com/",
  ariaLabel: "Conocé más sobre el producto en el sitio de ADF (se abre en una pestaña nueva)",
};

// Demo animada del teléfono: 4 escenas en loop. Datos ficticios; el CUIT va
// enmascarado como en el resto del client.
export const LANDING_DEMO = {
  regionLabel: "Demostración del trámite",
  pauseLabel: "Pausar demostración",
  playLabel: "Reproducir demostración",
  stepLabel: (step: number, total: number) => `Paso ${step} de ${total}`,
  captions: [
    "Verificá tu identidad",
    "Subí tus documentos",
    "Revisá y completá los datos",
    "Enviá tu solicitud",
  ],
  identity: {
    framing: "Encuadrá el frente del DNI",
    captured: "Frente capturado",
  },
  documents: {
    title: "Documentación",
    items: [
      { name: "Constancia de CUIT", status: "Leído", tone: "success" },
      { name: "Estatuto", status: "Procesando", tone: "info" },
      { name: "Acta de autoridades", status: "Pendiente", tone: "warn" },
    ],
  },
  review: {
    title: "Revisá tus datos",
    badge: "Leído de tus documentos",
    fields: [
      { label: "Razón social", value: "Empresa Ejemplo S.A.", mono: false },
      { label: "CUIT", value: "30-••••••••-9", mono: true },
      { label: "Domicilio legal", value: "Av. Ejemplo 1234, CABA", mono: false },
      { label: "Fecha de constitución", value: "12/03/2015", mono: true },
    ],
  },
  sent: {
    title: "Solicitud enviada",
    body: "Un ejecutivo la revisa y te avisamos por mail cuando haya una decisión.",
    status: "En revisión",
  },
} as const;

export const LANDING_FOOTER = {
  product: "AVA Onboarding",
  by: "by",
  adfLogoAlt: "ADF",
};
